<template>
    <div>
        <slot>
        </slot>
    </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
    export default class NavItemDropdown extends BaseComponent {

        protected mounted(): void {
            const parentEl = this.$el.parentElement;
            // TODO: rewrite this from a scratch.
            if (parentEl) {
                parentEl.addEventListener('mouseleave', () => {
                    Array.from(parentEl.querySelectorAll('.c-nav-list-item__link--submenu')).forEach((item: Element) => {
                        item.classList.remove('c-nav-list-item__link--active');
                    });
                    Array.from(parentEl.querySelectorAll('.c-nav-list')).forEach((item: Element) => {
                        (item as HTMLElement).style.display = 'none';
                    });
                });
            }
            Array.from(this.$el.querySelectorAll('.c-nav-list-item')).forEach((el: Element) => {
                el.addEventListener('mouseover', () => {
                    if (parentEl) {
                        Array.from(parentEl.querySelectorAll('.c-nav-list-item__link--submenu')).forEach((item: Element) => {
                            item.classList.remove('c-nav-list-item__link--active');
                        });
                        Array.from(parentEl.querySelectorAll('.c-nav-list')).forEach((item: Element) => {
                            (item as HTMLElement).style.display = 'none';
                        });
                    }
                    const link: HTMLElement | null = el.querySelector('.c-nav-list-item__link--submenu');
                    if (link) {
                        link.classList.add('c-nav-list-item__link--active');
                    }
                    const submenu: HTMLElement | null = el.querySelector('.c-nav-list');
                    if (link && submenu) {
                        const cndc = this.$el.querySelector('.c-nav-dropdown__content');
                        if (!cndc) {
                            return;
                        }
                        const cs = window.getComputedStyle(cndc, null);
                        const submenuLeft = parseInt(cs.getPropertyValue('padding-left'), 10) + link.offsetWidth;
                        const submenuTop = link.offsetTop - 35;
                        submenu.style.left = submenuLeft + 'px';
                        submenu.style.top = submenuTop + 'px';
                        submenu.style.display = 'block';
                    }
                });
            });
        }
    }
</script>
